<template>
    <div>
        <base-header class="pb-6 pb-8 pt-6 pt-md-6" type="gray-100">
          
        </base-header>

            <template v-if="loading">
                <div class="m-2">
                <skeleton altura="400px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
            </template>

        <div class="container-fluid mt--7" v-if="!loading">
            <div class="row">
                <div class="col-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Agendamento</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-2">
                                            <base-input alternative=""
                                                        label="Data"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.dated"
                                                        
                                            />
                                        </div>
                                        <div class="col-lg-2">
                                            <base-input alternative=""
                                                        label="Hora"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.hora"
                                            />
                                        </div>
                                          <div class="col-lg-4">
                                          <div class="form-group has-label"> 
                                             <label class="form-control-label"> 
                                                Status
                                             </label>

                                             <v-select 
                                                :options="status" 
                                                label="nome"
                                                class="form-control-alternative"
                                                v-model="model.status"
                                                >
                                                <template #option="option">
                                                   {{ option.nome }}
                                                </template>
                                               </v-select>
                                          </div>
                                               
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                label="Paciente (opcional)"
                                                input-classes="form-control-alternative"
                                                v-model="model.paciente"
                                                        
                                            />
                                        </div>
                                            <div class="col-lg-4">
                                                <base-input alternative=""
                                                label="Dentista (opcional)"
                                                input-classes="form-control-alternative"
                                                v-model="model.dentista"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>
                               

                                <div class="pl-lg-4">
                                    <div class="row">
                                       <div class="col-12 col-lg-8">
                                             
                                        
                                         <div class="form-group has-label"> 
                                             <label class="form-control-label"> 
                                                Protético Responsável
                                             </label>

                                               <v-select 
                                                :options="proteticos" 
                                                label="nomeCompleto"
                                                class="form-control-alternative"
                                                v-model="model.protetico"
                                                >
                                                <template #option="option">
                                                   {{ option.nomeCompleto }}
                                                </template>
                                               </v-select>
                                          </div>
                                          </div>
                                    </div>

                                    <div class="loadingProt" v-show="loadingProt">Carregando procedimentos...</div>

                                    <div class="row" v-show="procLoaded">
                                        <div class="col-12 col-lg-8">
                                          <div class="form-group has-label"> 
                                              <label class="form-control-label"> 
                                                 Procedimentos Protéticos
                                              </label>
 
                                              <multiselect
                                                v-model="model.procedimentos"
                                                track-by="id"
                                                label="nome"
                                                :options="procedimentos"
                                                placeholder="Selecione um Protético"
                                                :multiple="true"
                                                selectLabel="Selecionar"
                                                selectedLabel="✔"
                                                deselectLabel="Limpar"
                                                >
                                                <span slot="noResult">Todos os procedimentos</span>
                                            </multiselect>
                                           </div>
                                           </div>
                                     </div>

                                     <div class="" v-if="procedimentosQuant.length > 0 && procLoaded">
                                        <label class="form-control-label">Quantidade por Procedimento</label> 
                                        <ul>
                                            <li v-for="(proc, key) in procedimentosQuant" :key="key">
                                                <span>{{proc.nome}}</span>
                                                <span><input class="quant" type="number" min="0" v-model="valQuant[proc.id]" @click="updateProcQuant(proc.id, valQuant[proc.id], procedimentosQuant)"></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <hr class="my-4" />

                                 <div class="pl-lg-4">
                                    <div class="row">
                                       <div class="col-lg-12">
                                            <text-editor alternative=""
                                                label="Descritivo"
                                                type="textarea"
                                                input-classes="form-control-alternative height"
                                                v-model="model.descritivo"
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                  <hr class="my-4 mb-6" />
                                 <div class="pl-lg-4 text-right">

                                 <template v-if="loading2">
                                    <div class="m-2">
                                    <skeleton altura="100px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                    </div>
                                </template>

                                <div  v-if="!loading2">
                                 <base-button
                                    type="default"
                                    @click="salvar()"
                                    v-html="txt1"
                                    ></base-button>
                                </div>
                            </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import usuarios from '@/cflow/proteticos.js'
import agenda from '@/cflow/agendaProtetica.js'
  //import parametros from "@/cflow/parametros.js";
  //import BaseButton from '../../components/BaseButton.vue';
  import BaseInput from '../../components/BaseInput.vue';
  import Multiselect from "vue-multiselect";
  import storage from 'storage';
  import vSelect from "vue-select";
    import router from '@/router'
import "vue-select/dist/vue-select.css";
  export default {
    name: 'tables',
    components: {
     Multiselect,
      BaseInput,
      vSelect
    },
    watch: {
        'model.procedimentos': function(newVal) {

            if(this.hasProcData == true) {
                this.procedimentosQuant = newVal;

                let valQuant = this.valQuant
                this.procData.forEach(function(item){
                    valQuant[item.id] = item.quant;
                });
                this.valQuant = valQuant;

                this.hasProcData = false;
            } else {
                this.procedimentosQuant = newVal;

                let valQuant = this.valQuant
                newVal.forEach(function(item){
                    valQuant[item.id] = 0
                });
                this.valQuant = valQuant;
            }
           
        },
        'model.protetico': function(newVal) {

            if(newVal && newVal.id) {
                this.getProcs(null, newVal.id);
            }

        }
    },
    
    methods: {
        getProcs: function(idLab, idPro) {

            const _this = this;
            _this.loadingProt = true;
            _this.procLoaded = false;

            agenda.listarProcedimentos(idLab, idPro).then(res0 => {
                _this.procedimentos = res0;
                _this.loadingProt = false;
                _this.procLoaded = true;
            })

        },
        updateProcQuant: function(id, n) {
            let procList = this.procedimentosQuant;
            procList.forEach(function(item, k){
                if(item.id == id) {
                    procList[k].quant = n;
                }
            })

            this.procedimentosQuant = procList;
        },
        salvar: function() {

            this.loading2 = true;

            const _this = this;
        
        let form = this.model;
        const data = this.$route.params.data;
        const hora = this.$route.params.hora;

        form.data = data;
        form.hora = hora;

        const id = this.$route.params.id || '';

        agenda.salvar(id, form).then(() => {
                _this.loading = false;
                _this.hasSuccess = true;
                this.loading2 = false;
                 router.push('/agenda-protetica');
                
            }).catch(() => {
                _this.loading = false;
                _this.hasError = true;
                 setTimeout(function(){
                    _this.hasError = false;
                },5000);
            });

           
        }
    },
    data() {
      return {
        txt1: 'Salvar',
        tipo: null,
        id: null,
        status: [{'nome': 'Aguardando', 'valor': 'aguardando'}, {'nome': 'Em Produção', 'valor': 'producao'}, {'nome': 'Finalizado', 'valor': 'finalizado'}, {'nome': 'Cancelado', 'valor': 'cancelado'}],
        proteticos: [],
        hasSuccess: false,
        hasError: false,
        loading: false,
        loading2: false,
        loadingProt: false,
        procLoaded: false,
        dated: '',
        procedimentos: [],
        procedimentosQuant: [],
        valQuant: [],
        hasProcData: false,
        procData: [],
        model: {
          dated: '',
          data: '',
          hora: '',
          descritivo: '',
          status: ''
          
        }
      }
    },

     mounted(){
      //this.initLoad(0, 0);

      this.loading = true;

      const _tipo = this.$route.params.tipo;
      const _id = this.$route.params.id;


        const data = this.$route.params.data;
        const hora = this.$route.params.hora;

      if(!data || !hora) return;

      this.dated = this.formatarData2(data);

      this.tipo = _tipo;
      this.id = _id;

      let model = {
        dated: this.dated,
        data,
        hora
      }

      this.model = model;

      const _this = this;

      var user = storage.get("user");

      agenda.listarProcedimentos(_id, null).then(res0 => {

        if(_id) {
            this.procedimentos = res0;
        }

        //this.procedimentos = res0;

        usuarios.buscarPorLab(user.id).then(res => {

            this.proteticos = res;

            if(_id) {
                agenda.detalhes(_id).then(res => {
                    let model2 = {
                        status: res.status,
                        protetico: res.protetico,
                        paciente: res.paciente,
                        dentista: res.dentista,
                        descritivo: res.descritivo,
                        procedimentos: res.procedimentos,
                        dated: _this.model.dated,
                        hora: _this.model.hora,
                    }

                    if(res.procedimentos.length > 0) {
                        _this.hasProcData = true;
                        _this.procData = res.procedimentos;
                    }

                    _this.model = model2;
                    this.loading = false;
                
                }).catch((error) => {
                    console.err('ERROR', error)
                });
            } else {
                this.loading = false;
            }

        }).catch((error) => {
            console.err('ERROR', error)
        });

    }).catch((error) => {
        console.err('ERROR', error);
    });




    }
  };
</script>
<style>
.height, .ProseMirror {
    min-height: 300px;
}
.select {
    width: 100%;
    padding: 5px 5px;
}
.quant {
    margin: 0 0 0 20px;
    border: none;
    background: white;
    width: 100%;
    max-width: 80px;
    min-width: 50px;
    color: rgb(82, 95, 127);
}
.loadingProt {
    text-transform: uppercase;
    font-size: 14px;
    color: orange;
}
</style>
